<h1 mat-dialog-title translate>dialogInfo.title</h1>
<div mat-dialog-content translate>{{ text }}</div>
<div mat-dialog-actions>
  <button mat-stroked-button [mat-dialog-close]="false">
    <mat-label translate>dialogInfo.cancel</mat-label>
  </button>
  <button mat-flat-button color="accent" [mat-dialog-close]="true">
    <mat-label translate>dialogInfo.accept</mat-label>
  </button>
</div>
